import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IReceipt } from "src/domain/entities"
import { receiptDeleteService } from "src/domain/services/receipt/receiptDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	receipt: IReceipt
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ReceiptDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	receipt,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleReceiptDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await receiptDeleteService({ id: receipt.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [receipt, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Receipt: ${receipt.receiptNo}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleReceiptDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
